import type { ClasseCreee } from './api-prof.js';
import { T } from '../textes-interface.js';

/**
 * La planche de codes à découper.
 *
 * Chaque case porte un code d'îlot en gros caractères : elle finit découpée et
 * posée sur une table, à côté d'une tablette. C'est le seul lien entre un
 * groupe d'élèves et sa partie.
 */
export function PlancheDeCodes({
  classe,
  pin,
  onSuivi,
}: {
  classe: ClasseCreee;
  pin: string;
  onSuivi: () => void;
}) {
  return (
    <section className="space-y-4">
      <div className="rounded-2xl border-2 border-amber-300 bg-amber-50 p-4 print:hidden">
        <p className="font-semibold text-amber-900">{T.prof.conserverCode}</p>
        <dl className="mt-2 flex flex-wrap gap-x-8 gap-y-2">
          <div>
            <dt className="text-sm text-slate-600">{T.prof.codeClasse}</dt>
            <dd className="font-mono text-2xl font-bold tracking-widest">{classe.classCode}</dd>
          </div>
          <div>
            <dt className="text-sm text-slate-600">{T.prof.pin}</dt>
            <dd className="font-mono text-2xl font-bold tracking-widest">{pin}</dd>
          </div>
        </dl>
      </div>

      <header className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h2 className="text-xl font-bold text-slate-900">
            {T.prof.planche} — {classe.nom}
          </h2>
          <p className="text-sm text-slate-600 print:hidden">{T.prof.plancheAide}</p>
        </div>

        <div className="flex gap-2 print:hidden">
          <button
            type="button"
            onClick={() => globalThis.print()}
            className="min-h-touch rounded-xl bg-sky-600 px-4 font-semibold text-white hover:bg-sky-700"
          >
            {T.prof.imprimerPlanche}
          </button>
          <button
            type="button"
            onClick={onSuivi}
            className="min-h-touch rounded-xl bg-white px-4 font-semibold text-sky-700 ring-2 ring-sky-600"
          >
            {T.prof.allerAuSuivi}
          </button>
        </div>
      </header>

      <ul className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {classe.ilots.map((islandCode, index) => (
          <li
            key={islandCode}
            className="rounded-2xl border-2 border-dashed border-slate-400 p-5 text-center print:break-inside-avoid"
          >
            <p className="text-sm font-semibold uppercase tracking-wide text-slate-500">
              {classe.nom} · {index + 1}
            </p>
            <p className="mt-2 font-mono text-4xl font-bold tracking-[0.25em] text-slate-900">
              {islandCode}
            </p>
          </li>
        ))}
      </ul>
    </section>
  );
}
